import React from 'react';

const ReglesDeConfidentialites = () => {
    return (
        <div>
            Les regles de confidentialites
        </div>
    );
};

export default ReglesDeConfidentialites;